(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.WallanthemGymRenderer = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const WIDTH = 1680;
  const HEIGHT = 1035;
  const FAMILY = 'WaGymDisplay';
  const FONTS = Object.freeze({
    '1': Object.freeze([{family:FAMILY,asset:'wa-gym-display.woff2',weight:'400'}]),
    '2': Object.freeze([{family:'WaGymHeritage',asset:'wa-gym-heritage.ttf',weight:'400'},{family:'WaGymInterfaceBold',asset:'wa-gym-interface-bold.ttf',weight:'700'}])
  });
  function fontsForVersion(version) {
    const fonts=FONTS[String(version)];
    if(!fonts) throw new Error('Unsupported banner template version.');
    return fonts;
  }
  const DESIGNS = Object.freeze({
    'iron-resolve-lion': {layout:'side', accent:'#c5a067'},
    'earn-your-ground-tiger': {layout:'center', accent:'#eee5ce'},
    'built-by-the-work-gorilla': {layout:'side', accent:'#bad064'},
    'earn-your-legacy-viking': {layout:'center', accent:'#eee5ce'},
    'earn-every-inch': {layout:'side', accent:'#eee5ce'}
  });
  function font(context, size) { context.font = `${size}px ${FAMILY}`; }
  function normalizeName(name) { return String(name || '').normalize('NFKC').trim().toUpperCase().replace(/['’]S$/, '').trim(); }
  function heading(configuration) { return `${normalizeName(configuration.name) || 'YOUR NAME'}’S GYM`; }
  function splitLongWord(context, word, width) {
    const pieces = [];
    let piece = '';
    for (const character of Array.from(word)) {
      if (piece && context.measureText(piece + character).width > width) { pieces.push(piece); piece = character; }
      else piece += character;
    }
    if (piece) pieces.push(piece);
    return pieces;
  }
  function wrap(context, text, width) {
    const words = String(text).trim().split(/\s+/).flatMap(word => splitLongWord(context, word, width));
    const lines = [];
    let line = '';
    for (const word of words) {
      const next = line ? `${line} ${word}` : word;
      if (line && context.measureText(next).width > width) { lines.push(line); line = word; }
      else line = next;
    }
    if (line) lines.push(line);
    return lines;
  }
  function fitLines(context, text, box, maximumSize, maximumLines) {
    for (let size = maximumSize; size >= 12; size -= 1) {
      font(context, size);
      const lines = maximumLines === 1 ? [String(text)] : wrap(context, text, box[2]);
      const lineHeight = size * 1.14;
      if (lines.length <= maximumLines && lines.length * lineHeight <= box[3] && lines.every(line => context.measureText(line).width <= box[2])) return {lines,size,lineHeight};
    }
    throw new Error('Text cannot fit in the approved design.');
  }
  function textBox(context, text, box, maximumSize, maximumLines, color) {
    const fitted = fitLines(context, text, box, maximumSize, maximumLines);
    font(context, fitted.size);
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillStyle = color;
    const start = box[1] + (box[3] - fitted.lineHeight * fitted.lines.length) / 2 + fitted.lineHeight / 2;
    fitted.lines.forEach((line, index) => context.fillText(line, box[0] + box[2] / 2, start + index * fitted.lineHeight));
    return fitted;
  }
  function drawBannerV1(context, options) {
    const config = options.configuration;
    const design = DESIGNS[config.designId];
    if (!design || String(config.templateVersion) !== '1' || !options.art) throw new Error('Unsupported banner design.');
    const layout = options.layout || design.layout;
    const name = `${normalizeName(config.name) || 'YOUR NAME'}’S`;
    const motto = String(config.motto || '').normalize('NFKC').trim().toUpperCase();
    context.save();
    context.fillStyle = '#151715';
    context.fillRect(0,0,WIDTH,HEIGHT);
    context.drawImage(options.art,0,0,WIDTH,HEIGHT);
    if (layout === 'side') {
      const patriotic=config.designId==='earn-every-inch';
      textBox(context,name,patriotic?[1010,35,570,125]:[1010,70,570,125],112,1,'#eee5ce');
      textBox(context,'GYM',patriotic?[1010,420,570,150]:[1010,215,570,160],140,1,design.accent);
      textBox(context,motto,patriotic?[1010,620,570,285]:[1010,560,570,330],106,3,'#eee5ce');
      textBox(context,'WALLANTHEM',[1080,962,430,30],22,1,'#c0baa7');
    } else {
      const tiger=config.designId==='earn-your-ground-tiger';
      textBox(context,heading(config),tiger?[100,18,1480,86]:[100,48,1480,100],tiger?76:88,1,'#eee5ce');
      textBox(context,motto,[100,865,1480,95],80,1,'#eee5ce');
      textBox(context,'WALLANTHEM',[590,971,500,26],18,1,'#c0baa7');
    }
    if (options.mockup) {
      context.strokeStyle = '#232820'; context.lineWidth = 8; context.strokeRect(4,4,1672,1027);
      context.setLineDash([5,5]); context.lineWidth = 1; context.strokeStyle = '#8e8668'; context.strokeRect(16,16,1648,1003); context.setLineDash([]);
      for (const y of [47,988]) {
        context.beginPath(); context.arc(34,y,12,0,Math.PI*2); context.fillStyle='#b3a273'; context.fill();
        context.beginPath(); context.arc(34,y,7.5,0,Math.PI*2); context.fillStyle='#30322d'; context.fill();
      }
    }
    context.restore();
  }
  // Version 1 above is intentionally frozen. Orders keep the version accepted at checkout.
  function heritageFont(context,size,family='WaGymHeritage') {
    context.font=`${family==='WaGymInterfaceBold'?'700 ':''}${size}px ${family}`;
  }
  function measuredBlock(context,lines,lineHeight) {
    const measures=lines.map(line=>context.measureText(line));
    const ascent=Math.max(...measures.map(m=>m.actualBoundingBoxAscent || 0));
    const descent=Math.max(...measures.map(m=>m.actualBoundingBoxDescent || 0));
    return {width:Math.max(...measures.map(m=>m.width)),height:ascent+descent+(lines.length-1)*lineHeight,ascent,descent};
  }
  function heritageText(context,text,box,maximumSize,color,family='WaGymHeritage',maxLines=1) {
    let fitted;
    for(let size=maximumSize;size>=12;size--){
      heritageFont(context,size,family);
      const lines=maxLines===1?[String(text)]:wrap(context,text,box[2]);
      const lineHeight=size*1.12,metrics=measuredBlock(context,lines,lineHeight);
      if(lines.length<=maxLines && metrics.width<=box[2] && metrics.height<=box[3]) {fitted={lines,size,lineHeight,...metrics};break;}
    }
    if(!fitted)throw new Error('Text cannot fit in the approved design.');
    context.fillStyle=color;context.textAlign='center';context.textBaseline='alphabetic';
    const baseline=box[1]+(box[3]-fitted.height)/2+fitted.ascent;
    fitted.lines.forEach((line,index)=>context.fillText(line,box[0]+box[2]/2,baseline+index*fitted.lineHeight));
    return fitted;
  }
  function mottoParts(motto) {
    const words=motto.split(/\s+/).filter(Boolean);
    return {lead:words.slice(0,-1).join(' '),emphasis:words.at(-1)||''};
  }
  function heritageMotto(context,motto,box,accent,inline=false) {
    const parts=mottoParts(motto);
    if(!parts.lead) return heritageText(context,parts.emphasis,box,inline?86:122,accent);
    if(inline){
      let fit;
      for(let size=86;size>=16;size--){
        const leadSize=Math.round(size*.74);heritageFont(context,leadSize,'WaGymInterfaceBold');const lead=context.measureText(parts.lead);
        heritageFont(context,size);const emphasis=context.measureText(parts.emphasis);const gap=size*.25;
        const width=lead.width+gap+emphasis.width;
        const height=Math.max(lead.actualBoundingBoxAscent,emphasis.actualBoundingBoxAscent)+Math.max(lead.actualBoundingBoxDescent,emphasis.actualBoundingBoxDescent);
        if(width<=box[2] && height<=box[3]) {fit={size,leadSize,lead,emphasis,gap,width,height};break;}
      }
      if(!fit)throw new Error('Text cannot fit in the approved design.');
      context.textAlign='left';context.textBaseline='alphabetic';
      const x=box[0]+(box[2]-fit.width)/2,y=box[1]+(box[3]-fit.height)/2+Math.max(fit.lead.actualBoundingBoxAscent,fit.emphasis.actualBoundingBoxAscent);
      heritageFont(context,fit.leadSize,'WaGymInterfaceBold');context.fillStyle='#eee5ce';context.fillText(parts.lead,x,y);
      heritageFont(context,fit.size);context.fillStyle=accent;context.fillText(parts.emphasis,x+fit.lead.width+fit.gap,y);
      return fit;
    }
    const leadHeight=parts.lead.length>16?92:64,emphasisHeight=96,gap=26;
    const top=box[1]+(box[3]-leadHeight-gap-emphasisHeight)/2;
    heritageText(context,parts.lead,[box[0],top,box[2],leadHeight],70,'#eee5ce','WaGymInterfaceBold',2);
    return heritageText(context,parts.emphasis,[box[0],top+leadHeight+gap,box[2],emphasisHeight],122,accent);
  }
  function heritageRule(context,x,y,width,color) {
    context.fillStyle=color;context.globalAlpha=.8;context.fillRect(x,y,width,3);context.globalAlpha=1;
  }
  function drawBannerV2(context,options) {
    const config=options.configuration,design=DESIGNS[config.designId];
    if(!design || String(config.templateVersion)!=='2' || !options.art)throw new Error('Unsupported banner design.');
    const name=`${normalizeName(config.name)||'YOUR NAME'}’S`,motto=String(config.motto||'').normalize('NFKC').trim().toUpperCase();
    context.save();context.fillStyle='#151715';context.fillRect(0,0,WIDTH,HEIGHT);context.drawImage(options.art,0,0,WIDTH,HEIGHT);
    if(design.layout==='side'){
      const patriotic=config.designId==='earn-every-inch',x=1025,width=535;
      // Name and GYM share a compact visual group; the patriotic emblem keeps its original clear area.
      heritageText(context,name,[x,patriotic?49:148,width,patriotic?93:112],86,'#eee5ce','WaGymHeritage',name.length>21?2:1);
      heritageText(context,'GYM',[x,patriotic?410:290,width,patriotic?160:180],205,design.accent);
      heritageRule(context,x+19,patriotic?612:516,width-38,design.accent);
      heritageMotto(context,motto,[x,patriotic?649:558,width,patriotic?227:264],design.accent);
      heritageText(context,'WALLANTHEM',[x,965,width,23],21,'#c0baa7','WaGymInterfaceBold');
    }else{
      const tiger=config.designId==='earn-your-ground-tiger';
      heritageText(context,heading(config),tiger?[105,25,1470,69]:[178,63,1324,84],tiger?82:88,'#eee5ce');
      heritageMotto(context,motto,[150,875,1380,77],design.accent,true);
      heritageRule(context,590,965,500,design.accent);
      heritageText(context,'WALLANTHEM',[590,980,500,18],17,'#c0baa7','WaGymInterfaceBold');
    }
    if(options.mockup){
      context.strokeStyle='#232820';context.lineWidth=8;context.strokeRect(4,4,1672,1027);
      context.setLineDash([5,5]);context.lineWidth=1;context.strokeStyle='#8e8668';context.strokeRect(16,16,1648,1003);context.setLineDash([]);
      for(const y of[47,988]){context.beginPath();context.arc(34,y,12,0,Math.PI*2);context.fillStyle='#b3a273';context.fill();context.beginPath();context.arc(34,y,7.5,0,Math.PI*2);context.fillStyle='#30322d';context.fill();}
    }
    context.restore();
  }
  function drawBanner(context,options){
    const version=String(options.configuration.templateVersion);
    if(version==='1')return drawBannerV1(context,options);
    if(version==='2')return drawBannerV2(context,options);
    throw new Error('Unsupported banner template version.');
  }
  function drawScene(context, options) {
    const createCanvas = options.createCanvas || ((width,height) => { const canvas=document.createElement('canvas'); canvas.width=width; canvas.height=height; return canvas; });
    const fabric = createCanvas(WIDTH,HEIGHT);
    const surface = fabric.getContext('2d');
    drawBanner(surface,{...options,mockup:true});
    const light=surface.createLinearGradient(0,0,WIDTH,HEIGHT);
    light.addColorStop(0,'#ffffff15'); light.addColorStop(.4,'#ffffff00'); light.addColorStop(1,'#00000020');
    surface.fillStyle=light; surface.fillRect(0,0,WIDTH,HEIGHT);
    surface.lineWidth=1; surface.strokeStyle='#ffffff06'; surface.beginPath();
    for(let row=2;row<HEIGHT;row+=4){surface.moveTo(0,row);surface.lineTo(WIDTH,row);} surface.stroke();
    const placement=options.roomPlacement || {x:214,y:46,width:1108};
    const x=placement.x, y=placement.y, width=placement.width, height=width*34.5/56;
    context.save(); context.clearRect(0,0,1536,1024); context.drawImage(options.room,0,0,1536,1024);
    context.shadowColor='#00000060'; context.shadowBlur=15; context.shadowOffsetX=4; context.shadowOffsetY=8;
    context.fillStyle='#171815'; context.fillRect(x,y,width,height); context.shadowColor='transparent';
    for(let column=0;column<WIDTH;column+=4){const offset=Math.sin(column/WIDTH*Math.PI*4)*1.15;context.drawImage(fabric,column,0,4,HEIGHT,x+column*width/WIDTH,y+offset,4*width/WIDTH+.3,height);}
    for(const at of [.035,.5,.965]){
      const cx=x+width*at;context.fillStyle='#181a19';context.shadowColor='#0006';context.shadowBlur=3;context.shadowOffsetY=2;context.fillRect(cx-8,y-4,16,12);context.shadowColor='transparent';
      context.strokeStyle='#747771';context.lineWidth=1.3;context.beginPath();context.moveTo(cx-4,y-4);context.lineTo(cx-4,y-13);context.quadraticCurveTo(cx,y-19,cx+4,y-13);context.lineTo(cx+4,y-4);context.stroke();
    }
    context.restore();
    fabric.width=1;fabric.height=1;
  }
  return Object.freeze({WIDTH,HEIGHT,FAMILY,FONTS,fontsForVersion,DESIGNS,normalizeName,heading,fitLines,drawBanner,drawScene});
});
